import { render, staticRenderFns } from "./categoryForm.vue?vue&type=template&id=609db949&scoped=true&"
import script from "./categoryForm.vue?vue&type=script&lang=js&"
export * from "./categoryForm.vue?vue&type=script&lang=js&"
import style0 from "./categoryForm.vue?vue&type=style&index=0&id=609db949&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609db949",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('609db949')) {
      api.createRecord('609db949', component.options)
    } else {
      api.reload('609db949', component.options)
    }
    module.hot.accept("./categoryForm.vue?vue&type=template&id=609db949&scoped=true&", function () {
      api.rerender('609db949', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xcxPos/home/components/categoryForm.vue"
export default component.exports